module.exports = __webpack_public_path__ + "img/tour-3.ed6480d5.png";